module.exports = __webpack_public_path__ + "img/1791993057852.42572306.png";